import 'deepmerge';

function isValueInPixel(value) {
    return /^(\d)+px$/.test(value);
}
function isArFontSize(value) {
    return ['xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'xxxs'].indexOf(value) > -1
        || isValueInPixel(value);
}
function isHexColorCode(code) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(code);
}
function hexToRGBA(hex, opacity) {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + "," + (opacity === undefined ? 1 : opacity) + ")";
    }
    else {
        return null;
    }
}

var countryList = [
    {
        name: "Afghanistan",
        iso: "af",
        code: "+93"
    },
    {
        name: "Albania",
        iso: "al",
        code: "+355"
    },
    {
        name: "Algeria",
        iso: "dz",
        code: "+213"
    },
    {
        name: "Andorra",
        iso: "ad",
        code: "+376"
    },
    {
        name: "Angola",
        iso: "ao",
        code: "+244"
    },
    {
        name: "Anguilla",
        iso: "ai",
        code: "+1264"
    },
    {
        name: "Antigua & Barbuda",
        iso: "ag",
        code: "+1268"
    },
    {
        name: "Argentina",
        iso: "ar",
        code: "+54"
    },
    {
        name: "Armenia",
        iso: "am",
        code: "+374"
    },
    {
        name: "Aruba",
        iso: "aw",
        code: "+297"
    },
    {
        name: "Austria",
        iso: "at",
        code: "+43"
    },
    {
        name: "Australia",
        iso: "au",
        code: "+61"
    },
    {
        name: "Azerbaijan",
        iso: "az",
        code: "+994"
    },
    {
        name: "Bahamas",
        iso: "bs",
        code: "+1242"
    },
    {
        name: "Bahrain",
        iso: "bh",
        code: "+973"
    },
    {
        name: "Bangladesh",
        iso: "bd",
        code: "+880"
    },
    {
        name: "Barbados",
        iso: "bb",
        code: "+1246"
    },
    {
        name: "Belarus",
        iso: "by",
        code: "+375"
    },
    {
        name: "Belgium",
        iso: "be",
        code: "+32"
    },
    {
        name: "Belize",
        iso: "bz",
        code: "+501"
    },
    {
        name: "Benin",
        iso: "bj",
        code: "+229"
    },
    {
        name: "Bermuda",
        iso: "bm",
        code: "+1441"
    },
    {
        name: "Bhutan",
        iso: "bt",
        code: "+975"
    },
    {
        name: "Bolivia",
        iso: "bo",
        code: "+591"
    },
    {
        name: "Bosnia & Herzegovina",
        iso: "ba",
        code: "+387"
    },
    {
        name: "Botswana",
        iso: "bw",
        code: "+267"
    },
    {
        name: "Brazil",
        iso: "br",
        code: "+55"
    },
    {
        name: "British Virgin Islands",
        iso: "vg",
        code: "+1284"
    },
    {
        name: "Brunei",
        iso: "bn",
        code: "+673"
    },
    {
        name: "Bulgaria",
        iso: "bg",
        code: "+359"
    },
    {
        name: "Burkina Faso",
        iso: "bf",
        code: "+226"
    },
    {
        name: "Burundi",
        iso: "bi",
        code: "+257"
    },
    {
        name: "Cambodia",
        iso: "kh",
        code: "+855"
    },
    {
        name: "Cameroon",
        iso: "cm",
        code: "+237"
    },
    {
        name: "Canada",
        iso: "ca",
        code: "+1"
    },
    {
        name: "Cape Verde",
        iso: "cv",
        code: "+238"
    },
    {
        name: "Cayman Islands",
        iso: "ky",
        code: "+1345"
    },
    {
        name: "Central African Republic",
        iso: "cf",
        code: "+236"
    },
    {
        name: "Chad",
        iso: "td",
        code: "+235"
    },
    {
        name: "Chile",
        iso: "cl",
        code: "+56"
    },
    {
        name: "China",
        iso: "cn",
        code: "+86"
    },
    {
        name: "Colombia",
        iso: "co",
        code: "+57"
    },
    {
        name: "Comoros",
        iso: "km",
        code: "+269"
    },
    {
        name: "Congo (Brazzaville)",
        iso: "cg",
        code: "+242"
    },
    {
        name: "Congo (Kinshasa)",
        iso: "cd",
        code: "+243"
    },
    {
        name: "Costa Rica",
        iso: "cr",
        code: "+506"
    },
    {
        name: "Croatia",
        iso: "hr",
        code: "+385"
    },
    {
        name: "Cuba",
        iso: "cu",
        code: "+53"
    },
    {
        name: "Cyprus",
        iso: "cy",
        code: "+357"
    },
    {
        name: "Czech Republic",
        iso: "cz",
        code: "+420"
    },
    {
        name: "Côte d’Ivoire",
        iso: "ci",
        code: "+225"
    },
    {
        name: "Denmark",
        iso: "dk",
        code: "+45"
    },
    {
        name: "Djibouti",
        iso: "dj",
        code: "+253"
    },
    {
        name: "Dominica",
        iso: "dm",
        code: "+1767"
    },
    {
        name: "Dominican Republic",
        iso: "do",
        code: "+1809"
    },
    {
        name: "Ecuador",
        iso: "ec",
        code: "+593"
    },
    {
        name: "Egypt",
        iso: "eg",
        code: "+20"
    },
    {
        name: "El Salvador",
        iso: "sv",
        code: "+503"
    },
    {
        name: "Equatorial Guinea",
        iso: "gq",
        code: "+240"
    },
    {
        name: "Eritrea",
        iso: "er",
        code: "+291"
    },
    {
        name: "Estonia",
        iso: "ee",
        code: "+372"
    },
    {
        name: "Ethiopia",
        iso: "et",
        code: "+251"
    },
    {
        name: "Falkland Islands",
        iso: "fk",
        code: "+500"
    },
    {
        name: "Fiji",
        iso: "fj",
        code: "+679"
    },
    {
        name: "Finland",
        iso: "fi",
        code: "+358"
    },
    {
        name: "France",
        iso: "fr",
        code: "+33"
    },
    {
        name: "French Polynesia",
        iso: "pf",
        code: "+689"
    },
    {
        name: "Gabon",
        iso: "ga",
        code: "+241"
    },
    {
        name: "Gambia",
        iso: "gm",
        code: "+220"
    },
    {
        name: "Georgia",
        iso: "ge",
        code: "+995"
    },
    {
        name: "Germany",
        iso: "de",
        code: "+49"
    },
    {
        name: "Ghana",
        iso: "gh",
        code: "+233"
    },
    {
        name: "Gibraltar",
        iso: "gi",
        code: "+350"
    },
    {
        name: "Greece",
        iso: "gr",
        code: "+30"
    },
    {
        name: "Grenada",
        iso: "gd",
        code: "+1473"
    },
    {
        name: "Guatemala",
        iso: "gt",
        code: "+502"
    },
    {
        name: "Guernsey",
        iso: "gg",
        code: "+44-1481"
    },
    {
        name: "Guinea",
        iso: "gn",
        code: "+224"
    },
    {
        name: "Guinea-Bissau",
        iso: "gw",
        code: "+245"
    },
    {
        name: "Guyana",
        iso: "gy",
        code: "+592"
    },
    {
        name: "Haiti",
        iso: "ht",
        code: "+509"
    },
    {
        name: "Honduras",
        iso: "hn",
        code: "+504"
    },
    {
        name: "Hong Kong SAR China",
        iso: "hk",
        code: "+852"
    },
    {
        name: "Hungary",
        iso: "hu",
        code: "+36"
    },
    {
        name: "Iceland",
        iso: "is",
        code: "+354"
    },
    {
        name: "India",
        iso: "in",
        code: "+91"
    },
    {
        name: "Indonesia",
        iso: "id",
        code: "+62"
    },
    {
        name: "Iran",
        iso: "ir",
        code: "+98"
    },
    {
        name: "Iraq",
        iso: "iq",
        code: "+964"
    },
    {
        name: "Ireland",
        iso: "ie",
        code: "+353"
    },
    {
        name: "Isle of Man",
        iso: "im",
        code: "+44-1624"
    },
    {
        name: "Israel",
        iso: "il",
        code: "+972"
    },
    {
        name: "Italy",
        iso: "it",
        code: "+39"
    },
    {
        name: "Jamaica",
        iso: "jm",
        code: "+1876"
    },
    {
        name: "Japan",
        iso: "jp",
        code: "+81"
    },
    {
        name: "Jersey",
        iso: "je",
        code: "+44-1534"
    },
    {
        name: "Jordan",
        iso: "jo",
        code: "+962"
    },
    {
        name: "Kazakhstan",
        iso: "kz",
        code: "+7"
    },
    {
        name: "Kenya",
        iso: "ke",
        code: "+254"
    },
    {
        name: "Kosovo",
        iso: "xk",
        code: "+383",
    },
    {
        name: "Kuwait",
        iso: "kw",
        code: "+965"
    },
    {
        name: "Kyrgyzstan",
        iso: "kg",
        code: "+996"
    },
    {
        name: "Laos",
        iso: "la",
        code: "+856"
    },
    {
        name: "Latvia",
        iso: "lv",
        code: "+371"
    },
    {
        name: "Lebanon",
        iso: "lb",
        code: "+961"
    },
    {
        name: "Lesotho",
        iso: "ls",
        code: "+266"
    },
    {
        name: "Liberia",
        iso: "lr",
        code: "+231"
    },
    {
        name: "Libya",
        iso: "ly",
        code: "+218"
    },
    {
        name: "Liechtenstein",
        iso: "li",
        code: "+423"
    },
    {
        name: "Lithuania",
        iso: "lt",
        code: "+370"
    },
    {
        name: "Luxembourg",
        iso: "lu",
        code: "+352"
    },
    {
        name: "Macau SAR China",
        iso: "mo",
        code: "+853"
    },
    {
        name: "Macedonia",
        iso: "mk",
        code: "+389"
    },
    {
        name: "Madagascar",
        iso: "mg",
        code: "+261"
    },
    {
        name: "Malawi",
        iso: "mw",
        code: "+265"
    },
    {
        name: "Malaysia",
        iso: "my",
        code: "+60"
    },
    {
        name: "Maldives",
        iso: "mv",
        code: "+960"
    },
    {
        name: "Mali",
        iso: "ml",
        code: "+223"
    },
    {
        name: "Malta",
        iso: "mt",
        code: "+356"
    },
    {
        name: "Mauritania",
        iso: "mr",
        code: "+222"
    },
    {
        name: "Mauritius",
        iso: "mu",
        code: "+230"
    },
    {
        name: "Mexico",
        iso: "mx",
        code: "+52"
    },
    {
        name: "Micronesia",
        iso: "fm",
        code: "+691"
    },
    {
        name: "Moldova",
        iso: "md",
        code: "+373"
    },
    {
        name: "Monaco",
        iso: "mc",
        code: "+377"
    },
    {
        name: "Mongolia",
        iso: "mn",
        code: "+976"
    },
    {
        name: "Montenegro",
        iso: "me",
        code: "+382"
    },
    {
        name: "Montserrat",
        iso: "ms",
        code: "+1664"
    },
    {
        name: "Morocco",
        iso: "ma",
        code: "+212"
    },
    {
        name: "Mozambique",
        iso: "mz",
        code: "+258"
    },
    {
        name: "Myanmar (Burma)",
        iso: "mm",
        code: "+95"
    },
    {
        name: "Namibia",
        iso: "na",
        code: "+264"
    },
    {
        name: "Nepal",
        iso: "np",
        code: "+977"
    },
    {
        name: "Netherlands",
        iso: "nl",
        code: "+31"
    },
    {
        name: "New Zealand",
        iso: "nz",
        code: "+64"
    },
    {
        name: "Nicaragua",
        iso: "ni",
        code: "+505"
    },
    {
        name: "Niger",
        iso: "ne",
        code: "+227"
    },
    {
        name: "Nigeria",
        iso: "ng",
        code: "+234"
    },
    {
        name: "North Korea",
        iso: "kp",
        code: "+850"
    },
    {
        name: "Norway",
        iso: "no",
        code: "+47"
    },
    {
        name: "Oman",
        iso: "om",
        code: "+968"
    },
    {
        name: "Pakistan",
        iso: "pk",
        code: "+92"
    },
    {
        name: "Palau",
        iso: "pw",
        code: "+680"
    },
    {
        name: "Palestine",
        iso: "ps",
        code: "+970"
    },
    {
        name: "Panama",
        iso: "pa",
        code: "+507"
    },
    {
        name: "Papua New Guinea",
        iso: "pg",
        code: "+675"
    },
    {
        name: "Paraguay",
        iso: "py",
        code: "+595"
    },
    {
        name: "Peru",
        iso: "pe",
        code: "+51"
    },
    {
        name: "Philippines",
        iso: "ph",
        code: "+63"
    },
    {
        name: "Poland",
        iso: "pl",
        code: "+48"
    },
    {
        name: "Portugal",
        iso: "pt",
        code: "+351"
    },
    {
        name: "Puerto Rico",
        iso: "pr",
        code: "+1787"
    },
    {
        name: "Qatar",
        iso: "qa",
        code: "+974"
    },
    {
        name: "Romania",
        iso: "ro",
        code: "+40"
    },
    {
        name: "Russia",
        iso: "ru",
        code: "+7"
    },
    {
        name: "Rwanda",
        iso: "rw",
        code: "+250"
    },
    {
        name: "Saint Helena, Ascension & Tristan da Cunha",
        iso: "sh",
        code: "+290"
    },
    {
        name: "Samoa",
        iso: "ws",
        code: "+685"
    },
    {
        name: "San Marino",
        iso: "sm",
        code: "+378"
    },
    {
        name: "Saudi Arabia",
        iso: "sa",
        code: "+966"
    },
    {
        name: "Senegal",
        iso: "sn",
        code: "+221"
    },
    {
        name: "Serbia",
        iso: "rs",
        code: "+381"
    },
    {
        name: "Seychelles",
        iso: "sc",
        code: "+248"
    },
    {
        name: "Sierra Leone",
        iso: "sl",
        code: "+232"
    },
    {
        name: "Singapore",
        iso: "sg",
        code: "+65"
    },
    {
        name: "Slovakia",
        iso: "sk",
        code: "+421"
    },
    {
        name: "Slovenia",
        iso: "si",
        code: "+386"
    },
    {
        name: "Solomon Islands",
        iso: "sb",
        code: "+677"
    },
    {
        name: "Somalia",
        iso: "so",
        code: "+252"
    },
    {
        name: "South Africa",
        iso: "za",
        code: "+27"
    },
    {
        name: "South Korea",
        iso: "kr",
        code: "+82"
    },
    {
        name: "Spain",
        iso: "es",
        code: "+34"
    },
    {
        name: "Sri Lanka",
        iso: "lk",
        code: "+94"
    },
    {
        name: "St. Kitts & Nevis",
        iso: "kn",
        code: "+1869"
    },
    {
        name: "St. Lucia",
        iso: "lc",
        code: "+1758"
    },
    {
        name: "St. Vincent & Grenadines",
        iso: "vc",
        code: "+1784"
    },
    {
        name: "Sudan",
        iso: "sd",
        code: "+249"
    },
    {
        name: "Suriname",
        iso: "sr",
        code: "+597"
    },
    {
        name: "Swaziland",
        iso: "sz",
        code: "+268"
    },
    {
        name: "Sweden",
        iso: "se",
        code: "+46"
    },
    {
        name: "Switzerland",
        iso: "ch",
        code: "+41"
    },
    {
        name: "Syria",
        iso: "sy",
        code: "+963"
    },
    {
        name: "São Tomé & Príncipe",
        iso: "st",
        code: "+239"
    },
    {
        name: "Taiwan",
        iso: "tw",
        code: "+886"
    },
    {
        name: "Tajikistan",
        iso: "tj",
        code: "+992"
    },
    {
        name: "Tanzania",
        iso: "tz",
        code: "+255"
    },
    {
        name: "Thailand",
        iso: "th",
        code: "+66"
    },
    {
        name: "Timor-Leste",
        iso: "tl",
        code: "+670"
    },
    {
        name: "Togo",
        iso: "tg",
        code: "+228"
    },
    {
        name: "Tonga",
        iso: "to",
        code: "+676"
    },
    {
        name: "Trinidad & Tobago",
        iso: "tt",
        code: "+1868"
    },
    {
        name: "Tunisia",
        iso: "tn",
        code: "+216"
    },
    {
        name: "Turkey",
        iso: "tr",
        code: "+90"
    },
    {
        name: "Turkmenistan",
        iso: "tm",
        code: "+993"
    },
    {
        name: "Turks & Caicos Islands",
        iso: "tc",
        code: "+1649"
    },
    {
        name: "Uganda",
        iso: "ug",
        code: "+256"
    },
    {
        name: "Ukraine",
        iso: "ua",
        code: "+380"
    },
    {
        name: "United Arab Emirates",
        iso: "ae",
        code: "+971"
    },
    {
        name: "United Kingdom",
        iso: "gb",
        code: "+44"
    },
    {
        name: "United States",
        iso: "us",
        code: "+1"
    },
    {
        name: "Uruguay",
        iso: "uy",
        code: "+598"
    },
    {
        name: "Uzbekistan",
        iso: "uz",
        code: "+998"
    },
    {
        name: "Vanuatu",
        iso: "vu",
        code: "+678"
    },
    {
        name: "Venezuela",
        iso: "ve",
        code: "+58"
    },
    {
        name: "Vietnam",
        iso: "vn",
        code: "+84"
    },
    {
        name: "Yemen",
        iso: "ye",
        code: "+967"
    },
    {
        name: "Zambia",
        iso: "zm",
        code: "+260"
    },
    {
        name: "Zimbabwe",
        iso: "zw",
        code: "+263"
    }
];

const defaultTopCountries = ['us', 'gb', 'au'];

/**
 * This select is using the power of our ar-select, you can say it's an implementation of our ar-select.
 * If you want to see what it looks like, check our playbook page
 */
var ARCountrySelect = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ar-select',{staticClass:"ar-country-select",attrs:{"ar-widget-id":"ar-country-select","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":"ar-country-select","disabled":_vm.disabled,"items":_vm.items,"defaultSelectIndex":_vm.selectedIndex,"filter-placeholder":_vm.filterPlaceholder,"filter":_vm.countryFilter,"hide-arrow":false,"enable-clear":_vm.enableClear,"enable-filter":true,"hasError":_vm.hasError,"dropdown-width":_vm.dropdownWidth},on:{"select":_vm.handleSelect,"clear":_vm.handleClear},scopedSlots:_vm._u([{key:"selected-item",fn:function(selectedItemScope){return [(selectedItemScope.item)?_c('div',{style:({
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        padding: '0 14px',
      })},[_c('ar-flag-icon',{style:({
          marginRight: '10px'
        }),attrs:{"name":selectedItemScope.item.iso}}),_vm._v(" "),(_vm.valueType === 'code')?_c('ar-text',{attrs:{"size":_vm.inputFontSize,"text":selectedItemScope.item.code}}):_vm._e(),_vm._v(" "),(_vm.valueType === 'iso')?_c('ar-text',{attrs:{"size":_vm.inputFontSize,"text":selectedItemScope.item.name}}):_vm._e()],1):_c('div',{style:({
        display: 'flex',
        height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'center',
        padding: '0 14px',
      })},[_c('ar-text',{attrs:{"size":"xs","text":_vm.placeholder}})],1)]}},{key:"clear",fn:function(clearScope){return [_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '0 15px',
        height: '40px',
        cursor: 'pointer',
        background: clearScope.active ? _vm.hoveredColor : null,
        marginTop: '10px',
      })},[_c('ar-text',{attrs:{"size":"xs","text":_vm.placeholder}})],1)]}},{key:"item",fn:function(itemScope){return [_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '11px 15px',
        marginTop: itemScope.index === 0 && _vm.firstItemHasPaddingTop ? '10px' : null,
        marginBottom: itemScope.lastIndex ? '10px' : null,
        cursor: 'pointer',
        background: itemScope.active || itemScope.selected ? _vm.hoveredColor : null,
      })},[_c('ar-flag-icon',{style:({
          marginRight: '10px'
        }),attrs:{"name":itemScope.item.iso}}),_vm._v(" "),_c('ar-text',{style:({
          color: itemScope.active || itemScope.selected ? _vm.focusedColor : null,
        }),attrs:{"size":"xs","text":_vm.getItemText(itemScope.item),"weight":itemScope.selected ? 'bold' : 'normal'}})],1),_vm._v(" "),(itemScope.item.iso === _vm.topSelectionsByIsoSelected[_vm.topSelectionsByIsoSelected.length - 1])?_c('ar-divider',{style:({ margin: '10px 0' })}):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-item"},[_c('div',{style:({
        display: 'flex',
        alignItems: 'center',
        padding: '12px 15px',
      })},[_c('ar-text',{attrs:{"size":"xs","text":"No result"}})],1)])],2)},
staticRenderFns: [],
  name: 'CountryCodeSelect',
  props: {
    arWidgetMeta: String,
    value: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'purple',
      validator: (value) => {
        return ['purple'].indexOf(value) > -1 || isHexColorCode(value);
      },
    },
    enableClear: {
      type: Boolean,
      default: false,
    },
    valueType: {
      type: String,
      default: 'code',
      required: true,
      validator: (value) =>
        ['code', 'iso'].indexOf(value) !== -1,
    },
    dropdownWidth: {
      type: Number,
      default: null,
    },
    size: {
      type: String,
      default: 'md',
      validator: (val) => ['xs', 'md'].indexOf(val) > -1,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    inputFontSize: {
      type: String,
      default: 'xs',
      validator: isArFontSize,
    },
    topSelectionsByIso: {
      type: Array,
      default: () => defaultTopCountries,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let countrySelections = countryList;

    const topSelectionsByIsoSelected = this.topSelectionsByIso || defaultTopCountries; 

    if (!!this.topSelectionsByIsoSelected && this.topSelectionsByIsoSelected.length > 0) {
      this.topSelectionsByIsoSelected.forEach((isoSelection, index) => {
        let countryIsoIndex = countrySelections.findIndex((country) => {
          return country.iso === isoSelection
        });

        const newCountryIso = {
          ...countrySelections[countryIsoIndex]
        };

        countrySelections.splice(countryIsoIndex, 1);
        countrySelections.splice(index, 0, newCountryIso);
      });
    }

    return {
      realVal: this.value,
      items: countrySelections,
      topSelectionsByIsoSelected: topSelectionsByIsoSelected
    };
  },
  computed: {
    computedArWidgetMeta() {
      return [
        `value=${this.realVal};`,
        `valueType=${this.valueType};`,
      ].join('');
    },
    hoveredColor() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple100;
      }
      return hexToRGBA(this.color, 0.1);
    },
    focusedColor() {
      if (this.color === 'purple') {
        return this.$arStyle.color.purple500;
      }
      return this.color;
    },
    firstItemHasPaddingTop() {
      if (!this.enableClear) {
        return true;
      }
      return this.enableClear && this.selectedIndex === -1;
    },
    placeholder() {
      // valueType can only have values
      // 'code' or 'iso'
      if (this.valueType === 'iso') {
        return 'Select country...';
      }
      return this.size === 'xs' ? 'Select country...' : 'Select country code...';
    },
    selectedIndex() {
      // valueType can only have values
      // 'code' or 'iso'
      if (this.valueType === 'iso') {
        return this.items.findIndex(({ iso }) => iso === this.realVal);
      } else {
        return this.items.findIndex(({ code }) => code === this.realVal);
      }
    },
  },
  watch: {
    value(newValue) {
      this.realVal = newValue;
    },
  },
  methods: {
    countryFilter(item, filterString) {
      const lowerCaseFilterString = filterString.toLowerCase();
      return item.name.toLowerCase().indexOf(lowerCaseFilterString) > -1
        || item.code.toLowerCase().indexOf(lowerCaseFilterString) > -1
        || item.iso.toLowerCase().indexOf(lowerCaseFilterString) > -1;
    },
    filterPlaceholder(selectedItem) {
      if (selectedItem) {
        return this.valueType === 'code' ? selectedItem.code : selectedItem.name;
      } else {
        return this.placeholder;
      }
    },
    getItemText(item) {
      if (this.valueType === 'code') {
        return `${item.code} ${item.name}`;
      } else if (this.valueType === 'iso') {
        return item.name;
      }
    },
    handleClear() {
      this.realVal = null;
      this.$emit('input', null);
      this.$emit('clear');
    },
    handleSelect(item) {
      if (this.valueType === 'code') {
        this.realVal = item.code;
        this.$emit('input', item.code);
      } else if (this.valueType === 'iso') {
        this.realVal = item.iso;
        this.$emit('input', item.iso);
      }

      // Parents component can get whole object through this event
      this.$emit('select', item, this.selectedIndex);
    },
  },
};

export default ARCountrySelect;
